module.exports = __webpack_public_path__ + "static/media/winner-icon.77fa6774.png";